$(document).ready(function(){
    
    //On affiche le loader
    $("#bandeauVideoContent .chargement").fadeIn();

    //On lance la vidéo
    var player = $('#bandeauVideoContent').YTPlayer({
        containment: 'self',
        showControls: false,
        autoPlay:true,
        playOnlyIfVisible: false,
        mute:true,
        startAt:0,
        loop: 100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
        showYTLogo: false,
        stopMovieOnBlur: false,
        ratio: 'auto',
        opacity:1,
        quality: 'hd1080', //‘default’ or ‘small’, ‘medium’, ‘large’, ‘hd720’, ‘hd1080’, ‘highres’
    });

    //Quand tout est pret, on cache le loader, et on affiche le contenu
    jQuery('#bandeauVideoContent').on("YTPReady",function(e){
        $(this).children(".chargement").fadeOut(500,function(){
            $(".bandeau-interne").hide().removeClass("d-none").fadeIn();
        });
    });

});
